import { isPositiveNumber } from "et3-type-guards";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import PaidUserSelect from "../../shared/paid-user-select";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import SelectAllContainer from "./SelectAll";
import getKhattabatSelectsStore from "../../../../../stores/khattabat-stores/selects-store";
import Filter from "./filter";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";

const Form = withLiteObserverAndTheme(() => {
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1510}
      height={475}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <PaidUserSelect showCount />
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <Filter />
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isPositiveNumber(
          getKhattabatMatchingStore().currentClientInformation.get().userId
        )}
        onClick={async () => {
          getKhattabat101MGeneralStore().resetClientConversations();
          await getKhattabat101MGeneralStore().getMatchesConversations();
        }}
        type="SEND"
        size="LARGE"
        text="GET_CONVESATIONS"
      />
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1510}
        height={50}
        color={""}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={isPositiveNumber(
            getKhattabatSelectsStore().getMarkedUserIds().length
          )}
          onClick={async () => {
            await getKhattabat101MGeneralStore().disableEnableMatchConversationDatabase(
              {
                matchIDs: getKhattabatSelectsStore().getMarkedUserIds(),
                enableAllConversations: true,
                disableAllConversations: false
              }
            );
          }}
          type="SEND"
          size="LARGE"
          text="ENABLE_SELECTED_1O1M"
        />
        <Et3Margin top={0} bottom={0} left={20} right={20} />
        <Et3Button
          isEnabled={isPositiveNumber(
            getKhattabatSelectsStore().getMarkedUserIds().length
          )}
          onClick={async () => {
            await getKhattabat101MGeneralStore().disableEnableMatchConversationDatabase(
              {
                matchIDs: getKhattabatSelectsStore().getMarkedUserIds(),
                enableAllConversations: false,
                disableAllConversations: true
              }
            );
          }}
          type="SEND"
          size="LARGE"
          text="DISABLE_SELECTED_1O1M"
        />
      </ET3Div>
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <SelectAllContainer />
    </ET3Div>
  );
});

export default Form;
